import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useMutation } from '@apollo/client';
import { CustomBackdrop } from '../../components/backdrop';
import {
  IntroduceMutation,
  IntroduceMutationVariables,
  MarkActivityMutation,
  MarkActivityMutationVariables,
  UpdateUserLanguageMutation,
  UpdateUserLanguageMutationVariables,
} from '../../data-access/gql-types/graphql';
import { INTRODUCE } from '../../data-access/mutations/invitation';
import { MARK_ACTVITY, UPDATE_USER_LANGUAGE } from '../../data-access/mutations/user';
import { useNotify } from '../../hooks/notifications/use-notify';
import { useProfile } from '../../hooks/user';
import { ExalusBackdropPopup } from '../../integrations/exalus/components/exalus-backdrop-popup';
import { useUserActions } from '../../integrations/lavva/hooks/actions/use-user-actions';
import { useLavvaAppState } from '../../integrations/lavva/hooks/app-state';
import { useUserGroups } from '../../integrations/lavva/hooks/groups/use-user-groups';
import { useMeasurementMap } from '../../integrations/lavva/hooks/measurement-map/use-measurement-map';
import { ChannelSubscriptions } from '../../integrations/lavva/modules/channel-subscriptions';
import { BluetoothNotSupportedDialog } from '../../integrations/lavva/modules/device-add/components/bluetooth-not-supported-dialog';
import * as storage from '../../integrations/lavva/storage';
import { enableScroll } from '../../utils/helpers/scroll';
import { toastError } from '../../utils/toast';
import { prepareLanguageForRequest } from '../../utils/translations/sub-languages';

export const OverApp: React.FC = () => {
  const { t: tc, i18n } = useTranslation('common');
  const [invitationIntroduce] = useMutation<IntroduceMutation, IntroduceMutationVariables>(INTRODUCE);
  const [markActivity] = useMutation<MarkActivityMutation, MarkActivityMutationVariables>(MARK_ACTVITY);
  const [updateLanguage] = useMutation<UpdateUserLanguageMutation, UpdateUserLanguageMutationVariables>(
    UPDATE_USER_LANGUAGE,
  );
  useNotify();
  useUserGroups();
  useUserActions();
  useMeasurementMap();
  useLavvaAppState();
  const { userProfileData } = useProfile();

  useEffect(() => {
    markActivity();

    if (!storage.getItem('wasIntroduced')) {
      invitationIntroduce({
        onCompleted: (res) => {
          if (res.introduce) storage.setItem('wasIntroduced', true);
          else toastError({ content: tc('errors.somethingWentWrong') });
        },
      });
    }
  }, []);

  useEffect(() => {
    if (userProfileData?.userProfile?.userLanguage !== undefined) {
      if (userProfileData?.userProfile?.userLanguage === '') {
        updateLanguage({
          variables: {
            input: {
              language: prepareLanguageForRequest(i18n.language),
            },
          },
        });
      } else {
        i18n.changeLanguage(userProfileData.userProfile.userLanguage);
      }
    }
  }, [userProfileData?.userProfile?.userLanguage]);

  useEffect(() => {
    enableScroll();
  }, [location.pathname]);

  return (
    <>
      <CustomBackdrop />
      <ExalusBackdropPopup />
      <BluetoothNotSupportedDialog />
      {/* <NativeAppDialog /> */}

      <ChannelSubscriptions />
    </>
  );
};
